// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../app/design/frontend/Netlogiq/farmec/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ProductBundleItem-Wrapper{margin-bottom:1rem}.ProductBundleItem-Title{font-size:14px;font-weight:bold}.ProductBundleItem-Heading{font-weight:normal}.ProductBundleItem-HeadingBold{font-weight:bold}.ProductBundleItem-DropdownWrapper{display:flex}.ProductBundleItem-DropdownWrapper .Field_type_number{margin-left:1.2rem}.ProductBundleItem-Select{flex-grow:1}\n", ""]);
// Exports
module.exports = exports;
